import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { useBoardSelector } from '../../index';
import { getBoardTypeForAnalytics } from '../../selectors/software/software-selectors';
import { isSprintsEnabled } from '../../selectors/sprint/sprint-selectors';
import { workIssuesCountSelector } from '../../selectors/work/work-selectors';
import { useIsIncrementPlanningBoard } from '../capabilities';

const COLUMN_LENGTH_FOR_STICKY_ICC = 3;

export const useIsInIccExperimentTestCohort = (
	isColumnIccEnabled: boolean,
	issuesInColumn: number,
) => {
	if (!fg('jsw_sticky_icc_large_kanban_boards_fg')) {
		return false;
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const totalIssuesOnBoard = useBoardSelector(workIssuesCountSelector);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const boardType = useBoardSelector(getBoardTypeForAnalytics);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const sprintsEnabled = useBoardSelector(isSprintsEnabled);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const isIPBoard = useIsIncrementPlanningBoard();

	const isEligibleForStickyIccExperiment =
		!isIPBoard &&
		boardType !== 'Scrum' && // CMP Scrum boards
		!(boardType === 'Agility' && sprintsEnabled) && // TMP Scrum boards
		totalIssuesOnBoard >= 100 &&
		isColumnIccEnabled &&
		issuesInColumn >= COLUMN_LENGTH_FOR_STICKY_ICC;

	const isInStickyIccExperimentTestCohort =
		isEligibleForStickyIccExperiment &&
		expVal('jsw_sticky_icc_large_kanban_boards', 'isIccSticky', false);

	return isInStickyIccExperimentTestCohort;
};
